import { auth } from './auth'
import {
    setAuthBusy,
    setAuthError,
} from '../../../reducers/actions/auth'

/**
 * Send to email forgotten password link
 *
 * @param {string} email
 * @return {Promise}
 */
export const forgottenPassword = email => {
    setAuthBusy(true)

    return auth()
        .sendPasswordResetEmail(email)
        .catch(err => setAuthError(err.code))
        .finally(() => setAuthBusy(false))
}
